// extracted by mini-css-extract-plugin
module.exports = {"SHIPPING_RETURN":"ShippingReturn_SHIPPING_RETURN__3qc0v"};